import { EnvironmentProviders, Provider } from '@angular/core';
import { provideKeycloak } from 'keycloak-angular';
import { environment } from '../../../environments/environment';

export function fournirKeycloak(): (Provider | EnvironmentProviders)[] {
  return [
    provideKeycloak({
      config: {
        url: environment.keycloak.issuer,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId
      },
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false
      }
    })
  ];
}
